/* eslint-disable import/no-cycle */
// import Cookies from 'js-cookie';
import { DataService } from '../../../config/dataService/dataService';

export const loginApi = (values) => {
  return DataService.post('auth/login', values);
};

export const registerApi = (values) => {
  return DataService.post('auth/signup', values);
};

export const forgotPasswordApi = (values) => {
  return DataService.post('auth/forgot-password', values);
};

export const resetPasswordApi = (values) => {
  return DataService.post('auth/reset-password', values);
};

export const resendOTPApi = (values) => {
  return DataService.post('auth/resend-OTP', values);
};

export const emailVerifyApi = (values) => {
  return DataService.post('auth/verify-email', values);
};

export const getUserRoleApi = () => {
  return DataService.get('me-custom/permissions');
};

export const merchantMeApi = () => {
  return DataService.get('merchant/me');
};

export const staffMeApi = () => {
  // Must match merchant/sales-agent: no leading slash so axios joins baseURL correctly (e.g. .../api/staff/me).
  return DataService.get('staff/me');
};

export const salesAgentMeApi = () => {
  return DataService.get('sales-agent/me');
};

/** Normalize role from login/me payloads (string or { name, slug }). */
export function isStaffUserRole(role) {
  if (role == null) return false;
  if (typeof role === 'string') return role.trim().toLowerCase() === 'staff';
  if (typeof role === 'object') {
    const n = role.name ?? role.slug ?? role.role;
    return typeof n === 'string' && n.trim().toLowerCase() === 'staff';
  }
  return String(role).trim().toLowerCase() === 'staff';
}

export function isSalesAgentUserRole(role) {
  if (role == null) return false;
  if (typeof role === 'string') return role.trim().toLowerCase() === 'sales_agent';
  if (typeof role === 'object') {
    const n = role.name ?? role.slug ?? role.role;
    return typeof n === 'string' && n.trim().toLowerCase() === 'sales_agent';
  }
  return String(role).trim().toLowerCase() === 'sales_agent';
}

/** Resolves which /me endpoint to call: staff → /staff/me, sales_agent → /sales-agent/me, else merchant/me. */
export function getMeApiForRole(userRole) {
  if (isStaffUserRole(userRole)) return staffMeApi;
  if (isSalesAgentUserRole(userRole)) return salesAgentMeApi;
  return merchantMeApi;
}

/**
 * GET role-specific /me with optional Bearer override (must use fresh access_token from reset/login response when cookie may lag).
 */
export function requestMeForRole(userRole, accessTokenOverride) {
  const headers = accessTokenOverride ? { Authorization: `Bearer ${accessTokenOverride}` } : {};
  const cfg = Object.keys(headers).length ? { headers } : {};
  if (isStaffUserRole(userRole)) return DataService.get('staff/me', cfg);
  if (isSalesAgentUserRole(userRole)) return DataService.get('sales-agent/me', cfg);
  return DataService.get('merchant/me', cfg);
}

/**
 * Normalize API role values to a single slug string (e.g. staff, merchant, sales_agent, super_admin).
 * Ensures routing (RootRedirect) and getMeApiForRole work — objects like { name: "staff" } must not reach Redux as role.
 */
export function normalizeRoleSlug(raw) {
  if (raw == null || raw === '') return undefined;
  if (typeof raw === 'string') {
    const s = raw.trim().toLowerCase();
    if (s === 'sales-agent') return 'sales_agent';
    if (s === 'super-admin') return 'super_admin';
    return s;
  }
  if (typeof raw === 'object') {
    const n = raw.name ?? raw.slug ?? raw.role;
    if (typeof n === 'string') {
      return normalizeRoleSlug(n);
    }
  }
  const s = String(raw).trim().toLowerCase();
  if (s === 'sales-agent') return 'sales_agent';
  if (s === 'super-admin') return 'super_admin';
  return s || undefined;
}

/**
 * Login/signup payloads sometimes put role only on `user.role`, sometimes only in `user.roles[0]`.
 * Staff must resolve correctly so we call /staff/me (with permission_labels) not merchant/me.
 * Always returns a string slug when a role is present (never a raw object).
 */
export function resolveAuthRoleFromLoginUser(user) {
  if (!user) return undefined;
  const fromRoles = user.roles?.[0];
  if (fromRoles != null && fromRoles !== '') return normalizeRoleSlug(fromRoles);
  if (user.role != null && user.role !== '') return normalizeRoleSlug(user.role);
  return undefined;
}

/** Unwrap GET /staff/me, GET /sales-agent/me, and GET merchant/me responses into the profile object for auth.me */
export function parseMeResponsePayload(res) {
  const body = res?.data;
  if (!body || typeof body !== 'object') return null;
  const nested = body.data;
  if (nested != null && typeof nested === 'object' && !Array.isArray(nested)) {
    return nested;
  }
  return body;
}

export const selectLanguageApi = (values) => {
  return DataService.get(`language-list?lang=${values}`);
};
export const logoutApi = () => {
  return DataService.get('logout');
};
export const selectBusinessCategories = (values) => {
  return DataService.get(`business-category-list?lang=${values}`);
};
export const selectPaymentGateWayMethodsApi = (values) => {
  return DataService.get(`payment-gateway-method?lang=${values}`);
};
export const almaOnboardingApi = (data) => {
  return DataService.post('/user/alma-account-details', data);
};
export const updatePaymentMethodApi = (data) => {
  return DataService.post('/user/update-payment-method', data);
};
// export const selectPaymentStatus = (values) => {
//   return DataService.get(`payment-gateway-status?lang=${values}`);
// };
